//
import api from "./axios";

export const getUsageHistory = async (
  limit: number,
  start_time: string,
  end_time: string
) => {
  return await api.get("/api/web-api/get-usage-history", {
    params: {
      limit: limit,
      start_time: start_time,
      end_time: end_time,
    },
  });
};
